<template>
    <div class="flex w-full gap-5 h-full horse-color-view justify-content-around overflow-hidden">
        <div class="section-table w-full">
            <div class="flex justify-content-between align-items-center flex-wrap">
                <h2 class="page-header">{{ $t('message.horseColor.header') }}</h2>
                <CustomButton :label="$t('message.horseColor.addNewButton')" @click="addNewColor"/>
            </div>
            <HorseColorTable ref="horseColorTable" v-model="selectedColor" @showForm="showForm"/>
        </div>
        <LibyanOrnament/>
        <div id="scrollToForm" class="section-details">
            <div class="flex justify-content-between align-items-center pr-1">
                <h2 class="page-header">{{ createMode ? $t('message.horseColor.headerNew') : $t('message.horseColor.headerEdit') }}</h2>
                <CustomIconButton icon="pi pi-times" onlyIcon @click="hideForm" class="close-form-button" />
            </div>
            <HorseColorForm :selectedColor="selectedColor" @change-element="reloadTable"
                            @createMode="(val) => createMode = val" @hideForm="hideForm"/>
        </div>
    </div>
</template>

<script>
import HorseColorTable from "./components/HorseColorTable";
import HorseColorForm from "@/views/dict/horsecolor/components/HorseColorForm";
import CustomButton from "@/components/form/CustomButton.vue";
import { ScrollToUtils } from "@/utils/ScrollToUtils";
import LibyanOrnament from "@/components/LibyanOrnament.vue";
import CustomIconButton from "@/components/form/CustomIconButton.vue";
import { ShowHideFormUtils } from "@/utils/ShowHideFormUtils";

export default {
    name: "HorseColorListView",
    components: {
        LibyanOrnament,
        HorseColorTable,
        HorseColorForm,
        CustomButton,
        CustomIconButton,
    },
    data() {
        return {
            selectedColor: {},
            createMode: true,
        }
    },
    mounted() {
        this.selectedColor = this.getClearColor();
    },
    methods: {
        getClearColor() {
            return {
                id: null,
                name: "",
                shortName: "",
            };
        },
        reloadTable() {
            this.$refs.horseColorTable.reloadTable();
            this.selectedColor = this.getClearColor();
        },
        addNewColor() {
            ScrollToUtils.scrollToElement();
            this.$refs.horseColorTable.addNewColor();
            this.selectedColor = this.getClearColor();
            this.showForm();
        },
        showForm() {
            ShowHideFormUtils.showHideVertical(".section-table", ".section-details");
        },
        hideForm() {
            ShowHideFormUtils.showHideVertical(".section-table", ".section-details", true);
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "../../../assets/theme/mytheme/variables";
    .horse-color-view {
        @media screen and (max-width: 1200px) {
            flex-direction: column;
            align-items: center;
            .section-table, .section-details {
                width: 90% !important;
                overflow-y: unset;
                height: fit-content;
            }
            .close-form-button {
                display: none;
            }
        }
    }
    .section-table, .section-details {
        transition: 1s ease-in-out;
    }
    .section-details {
        height: calc(100vh - 40px - $top-bar-height);;
        overflow-y: auto;
        width: 0;
    }
</style>
